import { render, staticRenderFns } from "./MainTopCard.vue?vue&type=template&id=6138c91f&scoped=true&"
import script from "./MainTopCard.vue?vue&type=script&lang=js&"
export * from "./MainTopCard.vue?vue&type=script&lang=js&"
import style0 from "./MainTopCard.vue?vue&type=style&index=0&id=6138c91f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6138c91f",
  null
  
)

export default component.exports